import { useEffect, useState } from 'react';
import { migrationV1V2Api } from '../api/migration-v1-v2';
import type { AssignableUser } from '../api/migration-v1-v2';

/**
 * Charge la liste des utilisateurs assignables (réservée aux admins). À
 * n'activer que lorsque l'utilisateur courant est admin — sinon l'endpoint
 * répond 403. Le résultat est mis en cache au niveau de l'API, donc plusieurs
 * appels de ce hook ne déclenchent qu'une seule requête réseau.
 */
export function useAssignableUsers(enabled: boolean): AssignableUser[] {
  const [users, setUsers] = useState<AssignableUser[]>([]);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    migrationV1V2Api
      .getAssignableUsers()
      .then((u) => {
        if (!cancelled) setUsers(u);
      })
      .catch(() => {
        if (!cancelled) setUsers([]);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return users;
}
